module.exports = __webpack_public_path__ + "static/media/tp6.ccbc543c.jpg";